import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom'
import App from '@APP';
import reportWebVitals from './reportWebVitals';
import "@/assets/iconfont/iconfont.css"
import { i18nClient } from "@sailor/i18n-web";
import resources from '@/assets/locales/resources.ts';
import { initCookieManage } from '@sailor/cookie-manage';

i18nClient.init({
  ns: 'brand_assets_inner_web',
  fallbackLng: 'en',
  lng: 'en',
  resources,
   interpolation: {
    escapeValue: false, // 翻译中插入的变量是否开启转义
  },
   react: {
    useSuspense: false,// 翻译加载异步流程中是否使用Suspense组件展示等待
  },
  parseMissingKeyHandler: (key) => {
    return '';
  },
});

initCookieManage({
  necessaryCookies: [],

  onPreferenceChange: (preferences) => {
    console.log('Preferences changed:', preferences)
    if (preferences.analytics) {
    	// 打开灵犀读写Cookie
      window?.LXAnalytics('openCkAccess')
    }
  },
})

const Root = () => {
  return (
    <BrowserRouter basename='/'>
      <Route path={`/`} component={App}></Route>
    </BrowserRouter>
  )

}

ReactDOM.render(<Root />, document.querySelector('#app'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
